/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PracticeInternshipsPerDomainReportDTO,
	PracticeInternshipsPerDomainReportDTOFromJSON,
	PracticeInternshipsPerDomainReportDTOFromJSONTyped,
	PracticeInternshipsPerDomainReportDTOToJSON,
} from "./PracticeInternshipsPerDomainReportDTO";

/**
 *
 * @export
 * @interface PracticeInternshipsPerDomainReportDTOPagedResponse
 */
export interface PracticeInternshipsPerDomainReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PracticeInternshipsPerDomainReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PracticeInternshipsPerDomainReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PracticeInternshipsPerDomainReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PracticeInternshipsPerDomainReportDTO>}
	 * @memberof PracticeInternshipsPerDomainReportDTOPagedResponse
	 */
	data?: Array<PracticeInternshipsPerDomainReportDTO> | null;
}

export function PracticeInternshipsPerDomainReportDTOPagedResponseFromJSON(
	json: any
): PracticeInternshipsPerDomainReportDTOPagedResponse {
	return PracticeInternshipsPerDomainReportDTOPagedResponseFromJSONTyped(
		json,
		false
	);
}

export function PracticeInternshipsPerDomainReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeInternshipsPerDomainReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(
					PracticeInternshipsPerDomainReportDTOFromJSON
			  ),
	};
}

export function PracticeInternshipsPerDomainReportDTOPagedResponseToJSON(
	value?: PracticeInternshipsPerDomainReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(
						PracticeInternshipsPerDomainReportDTOToJSON
				  ),
	};
}
